import React, { useMemo } from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

const RichTextNotes = ({ value, onChange, placeholder = 'Additional notes', readOnly = false }) => {
  const modules = useMemo(() => ({
    toolbar: readOnly ? false : [
      ['bold', 'italic', 'underline'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['clean'],
    ],
  }), [readOnly]);

  const formats = ['bold', 'italic', 'underline', 'list'];

  return (
    <div data-testid="rich-text-notes" className="rich-text-notes">
      <style>{`
        .rich-text-notes .ql-container { min-height: 60px; font-size: 14px; }
        .rich-text-notes .ql-editor { min-height: 60px; }
        .rich-text-notes .ql-toolbar { border-top-left-radius: 6px; border-top-right-radius: 6px; background: #f8fafc; }
        .rich-text-notes .ql-container { border-bottom-left-radius: 6px; border-bottom-right-radius: 6px; }
        .rich-text-notes .ql-editor.ql-blank::before { color: #94a3b8; font-style: normal; }
      `}</style>
      <ReactQuill
        theme="snow"
        value={value || ''}
        onChange={onChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
        readOnly={readOnly}
      />
    </div>
  );
};

export default RichTextNotes;
